import { render } from "./Infinitescrolltrigger.vue?vue&type=template&id=8cad2bea&scoped=true"
import script from "./Infinitescrolltrigger.vue?vue&type=script&lang=js"
export * from "./Infinitescrolltrigger.vue?vue&type=script&lang=js"

import "./Infinitescrolltrigger.vue?vue&type=style&index=0&id=8cad2bea&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cad2bea"]])

export default __exports__